// Common UI strings — buttons, statuses, and verbs reused across surfaces.

import { PUBLIC_PRODUCT_NAME } from "@loom/shared/brand";

import type { MsgSection } from "./types.js";

export const common: MsgSection = {
  "common.send": { en: "Send", de: "Senden" },
  "common.cancel": { en: "Cancel", de: "Abbrechen" },
  "common.save": { en: "Save", de: "Speichern" },
  "common.retry": { en: "Retry", de: "Erneut versuchen" },
  "common.add": { en: "Add", de: "Hinzufügen" },
  "common.remove": { en: "Remove", de: "Entfernen" },
  "common.edit": { en: "Edit", de: "Bearbeiten" },
  "common.close": { en: "Close", de: "Schliessen" },
  "common.confirm": { en: "Confirm", de: "Bestätigen" },
  "common.reject": { en: "Reject", de: "Ablehnen" },
  "common.back": { en: "Back", de: "Zurück" },
  "common.continue": { en: "Continue", de: "Weiter" },
  "common.loading": { en: "Loading…", de: "Wird geladen…" },
  "common.justNow": { en: "just now", de: "gerade eben" },
  "common.you": { en: "You", de: "Du" },
  "common.loom": { en: "Loom", de: "Loom" },
  // The frame's brand word (`FocusFrame`, the boot frame), which every
  // signed-out page shows too. `common.loom` stays the chat's speaker label.
  "common.brand": { en: PUBLIC_PRODUCT_NAME, de: PUBLIC_PRODUCT_NAME },

  // ── RouteError / RouteNotFound ─────────────────────────────────────────
  // The screen a failing route loader shows. The router's own default is
  // "Something went wrong! / Show Error" over the thrown string — which, for a
  // failed HTTP call, is the status plus the upstream's body verbatim.
  "routeError.headline": {
    en: "This page didn’t load",
    de: "Diese Seite wurde nicht geladen",
  },
  "routeError.body.generic": {
    en: "Something went wrong on the way to this page. Try again — if it keeps happening, go back to the start.",
    de: "Auf dem Weg zu dieser Seite ist etwas schiefgelaufen. Versuch es nochmals — wenn es bleibt, geh zurück zum Anfang.",
  },
  "routeError.body.busy": {
    en: `${PUBLIC_PRODUCT_NAME} is busy right now. Try again in a moment — this usually clears on its own.`,
    de: `${PUBLIC_PRODUCT_NAME} ist gerade ausgelastet. Versuch es gleich nochmals — das gibt sich meist von selbst.`,
  },
  "routeError.body.notFound": {
    en: "There is nothing here. The link may be wrong, or what it pointed at is gone.",
    de: "Hier ist nichts. Der Link stimmt vielleicht nicht, oder das Ziel gibt es nicht mehr.",
  },
  "routeError.body.denied": {
    en: "You can’t open this. Sign in again, or ask an administrator for access.",
    de: "Du kannst das nicht öffnen. Melde dich neu an oder bitte eine Administratorin oder einen Administrator um Zugriff.",
  },
  "routeError.notFound.headline": {
    en: "Nothing at this address",
    de: "Unter dieser Adresse ist nichts",
  },
  "routeError.goHome": { en: `Go to ${PUBLIC_PRODUCT_NAME}`, de: `Zu ${PUBLIC_PRODUCT_NAME}` },
  "routeError.showDetail": {
    en: "Show what the server said",
    de: "Anzeigen, was der Server gemeldet hat",
  },
  "routeError.hideDetail": { en: "Hide it", de: "Ausblenden" },
};
